var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8095 19.6453C16.215 20.1181 16.8724 20.1181 17.2779 19.6453C17.6834 19.1725 17.6834 18.4059 17.2779 17.9331L10.4743 9.99992L17.2778 2.0669C17.6833 1.59409 17.6833 0.827511 17.2778 0.354702C16.8723 -0.118107 16.2149 -0.118107 15.8094 0.354702L9.0059 8.28773L2.20235 0.354607C1.79687 -0.118202 1.13944 -0.118202 0.733955 0.354607C0.328468 0.827416 0.328468 1.59399 0.733955 2.0668L7.5375 9.99992L0.733803 17.9332C0.328316 18.406 0.328316 19.1726 0.733803 19.6454C1.13929 20.1182 1.79672 20.1182 2.2022 19.6454L9.0059 11.7121L15.8095 19.6453Z",
    fill: "#005FC8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.376dc187.svg";
export { ForwardRef as ReactComponent };